import { HeaderTheme } from 'components/Header';
import { HomeNavSection, HomeNavTheme } from 'components/HomeNav';
import { ReactNode } from 'react';
import { Capabilities } from './Capabilities/Capabilities';
import { CaseStudies } from './CaseStudies';
import { Challenges } from './Challenges/Challenges';
import { Companies } from './Companies/Companies';
import { CompanyScope } from './CompanyScope/CompanyScope';

import { Differentials } from './Differentials/Differentials';
import { Founders } from './Founders/Founders';
import { Mission } from './Mission/Mission';
import { OurSuperheroes } from './OurSuperheroes/OurSuperheroes';
import { ServicesOffered } from './ServicesOffered/ServicesOffered';
import { Welcome } from './Welcome/Welcome';
import { WhatWeDo } from './WhatWeDo/WhatWeDo';
import { getCaseStudySectionHeaderTheme } from './helpers';
import { FooterSection } from 'components/FooterSection';

export const PAGE_NAVIGATION_GROUPS_NAMES = {
  HOME: 'home',
  WHAT_WE_DO: 'what-we-do',
  BOUTIQUE_CONSULTANCY: 'boutique-consultancy',
  OUR_CHALLENGES: 'our-challenges',
  CAPABILITIES: 'capabilities',
  CASE_STUDIES: 'case-studies',
  HOW_WE_DO_IT: 'how-we-do-it',
  FOUNDERS_AND_LEADERSHIP: 'founders-and-leadership',
  LETS_TALK: 'lets-talk',
} as const;

type PageNavigationGroupName = (typeof PAGE_NAVIGATION_GROUPS_NAMES)[keyof typeof PAGE_NAVIGATION_GROUPS_NAMES];

export const NAVIGATION_SECTIONS: HomeNavSection[] = [
  {
    name: 'HOME',
    id: PAGE_NAVIGATION_GROUPS_NAMES.HOME,
  },
  {
    name: 'WHAT WE DO',
    id: PAGE_NAVIGATION_GROUPS_NAMES.WHAT_WE_DO,
  },
  {
    name: 'OUR EXPERIENCES',
    id: PAGE_NAVIGATION_GROUPS_NAMES.OUR_CHALLENGES,
  },
  {
    name: 'CAPABILITIES',
    id: PAGE_NAVIGATION_GROUPS_NAMES.CAPABILITIES,
  },
  { name: 'OUR WORK', id: PAGE_NAVIGATION_GROUPS_NAMES.CASE_STUDIES },
  {
    name: 'HOW WE DO IT',
    id: PAGE_NAVIGATION_GROUPS_NAMES.HOW_WE_DO_IT,
  },
  {
    name: 'FOUNDERS & LEADERSHIP',
    id: PAGE_NAVIGATION_GROUPS_NAMES.FOUNDERS_AND_LEADERSHIP,
  },
  {
    name: 'LETS TALK!',
    id: PAGE_NAVIGATION_GROUPS_NAMES.LETS_TALK,
  },
];

export const APPLICATION_SLIDES: {
  content: ReactNode;
  getHeaderTheme: (width: number) => HeaderTheme;
  navigationTheme: HomeNavTheme;
  hideNavigation?: boolean;
  pageNavigationGroupName: PageNavigationGroupName;
  pageIdentifier?: PageNavigationGroupName;
}[] = [
  {
    content: (
      <Welcome screenId={PAGE_NAVIGATION_GROUPS_NAMES.HOME} nextScreenId={PAGE_NAVIGATION_GROUPS_NAMES.WHAT_WE_DO} />
    ),
    getHeaderTheme: () => 'light',
    navigationTheme: 'light',
    hideNavigation: true,
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.HOME,
  },
  {
    content: (
      <Mission
        screenId={PAGE_NAVIGATION_GROUPS_NAMES.WHAT_WE_DO}
        nextScreenId={PAGE_NAVIGATION_GROUPS_NAMES.BOUTIQUE_CONSULTANCY}
      />
    ),
    getHeaderTheme: () => 'dark',
    navigationTheme: 'dark',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.WHAT_WE_DO,
  },
  {
    content: <WhatWeDo screenId={PAGE_NAVIGATION_GROUPS_NAMES.BOUTIQUE_CONSULTANCY} />,
    getHeaderTheme: () => 'light',
    navigationTheme: 'light',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.WHAT_WE_DO,
    pageIdentifier: PAGE_NAVIGATION_GROUPS_NAMES.BOUTIQUE_CONSULTANCY,
  },
  {
    content: <CompanyScope />,
    getHeaderTheme: () => 'dark',
    navigationTheme: 'dark',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.WHAT_WE_DO,
  },
  {
    content: <OurSuperheroes />,
    getHeaderTheme: () => 'dark',
    navigationTheme: 'dark',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.WHAT_WE_DO,
  },
  {
    content: <Companies screenId={PAGE_NAVIGATION_GROUPS_NAMES.OUR_CHALLENGES} />,
    getHeaderTheme: () => 'light',
    navigationTheme: 'light',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.OUR_CHALLENGES,
  },
  {
    content: <Challenges />,
    getHeaderTheme: () => 'dark',
    navigationTheme: 'dark',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.OUR_CHALLENGES,
  },
  {
    content: <ServicesOffered screenId={PAGE_NAVIGATION_GROUPS_NAMES.CAPABILITIES} />,
    getHeaderTheme: () => 'light',
    navigationTheme: 'light',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.CAPABILITIES,
  },
  {
    content: <Capabilities />,
    getHeaderTheme: () => 'light',
    navigationTheme: 'dark',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.CAPABILITIES,
  },
  {
    content: <CaseStudies screenId={PAGE_NAVIGATION_GROUPS_NAMES.CASE_STUDIES} />,
    getHeaderTheme: getCaseStudySectionHeaderTheme,
    navigationTheme: 'light',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.CASE_STUDIES,
  },
  {
    content: <Differentials screenId={PAGE_NAVIGATION_GROUPS_NAMES.HOW_WE_DO_IT} />,
    getHeaderTheme: () => 'light',
    navigationTheme: 'light',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.HOW_WE_DO_IT,
  },
  {
    content: <Founders screenId={PAGE_NAVIGATION_GROUPS_NAMES.FOUNDERS_AND_LEADERSHIP} />,
    getHeaderTheme: () => 'light',
    navigationTheme: 'dark',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.FOUNDERS_AND_LEADERSHIP,
  },
  {
    content: <FooterSection screenId={PAGE_NAVIGATION_GROUPS_NAMES.LETS_TALK} />,
    getHeaderTheme: () => 'light',
    navigationTheme: 'light',
    pageNavigationGroupName: PAGE_NAVIGATION_GROUPS_NAMES.LETS_TALK,
  },
];
